import { ActionsObservable, ofType } from 'redux-observable';
import {
  AdminAppAction,
  DuplicatePageAction,
  PageActionType,
  loadImage,
  loadPageRequest,
  loadPageSuccess,
  pushAdminPanel,
} from '../../actions';
import { AdminPanelName, PagesState } from '../../state';
import { Observable, of } from 'rxjs';
import { mergeAll, switchMap } from 'rxjs/operators';
import { EpicDependencies } from '../epic-dependencies';
import { push } from 'connected-react-router';

export const duplicatePageEpic = <S extends { pages: PagesState }>(
  action$: ActionsObservable<DuplicatePageAction>,
  state: S,
  { site }: EpicDependencies,
): Observable<any> =>
  action$.pipe(
    ofType<AdminAppAction, DuplicatePageAction>(PageActionType.DuplicatePage),
    switchMap(async (action: DuplicatePageAction) => {
      const page = await site.pages.duplicate(action.pageId);

      const imageActions = page.images.map(posterImage =>
        loadImage(posterImage.image.id, {
          id: posterImage.image.id,
          url: posterImage.image.url,
        }),
      );

      const posterImages = page.images.map(posterImage => ({
        imageKey: posterImage.image.id,
        type: posterImage.type as any, // TODO: type...
      }));

      const tags = page.tags.map(tag => tag.name).join(' ');

      const actions = [
        loadPageRequest(page.id),
        loadPageSuccess(page.id, {
          content: page.content,
          description: page.description,
          id: page.id,
          path: page.path,
          posterImages,
          publishAt: page.publishAt ? page.publishAt.toISOString() : null,
          tags,
          title: page.title,
        }),
        ...(imageActions as any),
      ];

      if (action.options.redirect === 'view') {
        actions.push(push(`/admin/page?pageId=${page.id}`));
      } else if (action.options.redirect === 'edit') {
        actions.push(push(`/admin/page?pageId=${page.id}&edit=true`));

        actions.push(
          pushAdminPanel(AdminPanelName.Page, {
            pageKey: page.id,
            isNewPage: true,
          }),
        );
      }

      return of(...actions);
    }),
    mergeAll(),
  );
